import { Card } from "react-bootstrap";
import HelperService from "../utility/HelperService";

interface propData {
  buckets: any[];
  optionalItems?: any[] | null;
}

const formatAmount = (value: any) => `$${HelperService.getCurrencyFormatter(value ?? 0)}`;

const toNumber = (value: any) => Number(value) || 0;

export const getSalesQuoteFinalAmount = (bucket: any) =>
  toNumber(bucket?.total) + toNumber(bucket?.totalAddons) - toNumber(bucket?.totalCoupons) +
  toNumber(bucket?.optionalItemsAmount) - toNumber(bucket?.downPayment);

// Optional items are returned at quote level; an item tied to a bucket is shown only under that bucket
const getOptionalItems = (bucket: any, optionalItems?: any[] | null): any[] =>
  (optionalItems || []).filter((item: any) => item.showToCustomer !== false && (!item.bucketOrderId || String(item.bucketOrderId) === String(bucket.orderId)));

const SummaryCell = ({ label, value }: { label: string; value: any }) => (
  <div className="sales-quote-summary-cell">
    <span className="sales-quote-summary-label fw-bold">{label}</span>
    <span className="sales-quote-summary-value">{formatAmount(value)}</span>
  </div>
);

const SalesQuoteDetailQuote = (props: propData) => {
  return (
    <>
      {(props.buckets || []).map((bucket: any, bucketIndex: number) => {
        const optionalItems = getOptionalItems(bucket, props.optionalItems);
        const total = toNumber(bucket.total);
        const addons = toNumber(bucket.totalAddons);
        const coupons = toNumber(bucket.totalCoupons);
        const optional = toNumber(bucket.optionalItemsAmount);
        const paymentReceived = toNumber(bucket.downPayment);
        const subtotal = total + addons - coupons;
        const final = getSalesQuoteFinalAmount(bucket);
        const description = bucket.notes;
        const barStyle = { backgroundColor: bucket.headerColor };

        return (
          <Card
            key={bucket.orderId || bucket.label || bucketIndex}
            className="card-style form-style invoice-call-picture-card p-0 overflow-hidden"
            style={{ marginBottom: 50 }}
          >
            <div className="d-flex justify-content-between align-items-center px-3 py-2 fw-bold fs-4 text-uppercase" style={barStyle}>
              <span>{bucket.label}</span>
              <span>{formatAmount(final)}</span>
            </div>

            <div className="p-3">
              {description && <div className="mb-2">{description}</div>}

              {(bucket.equipments || [])
                .filter((equipment: any) => equipment.showToCustomer !== false)
                .map((equipment: any, index: number) => (
                  <div className="d-flex mb-3" key={`${equipment.partNumber}-${index}`}>
                    <div className="me-3 flex-shrink-0" style={{ width: 160 }}>
                      {equipment.imageURL && <img src={equipment.imageURL} style={{ maxWidth: '100%', maxHeight: 130, objectFit: 'contain' }} />}
                    </div>
                    <div className="flex-grow-1">
                      <div className="d-flex fw-bold">
                        <div style={{ width: '35%' }}>{equipment.partNumber}</div>
                        <div style={{ width: '35%' }}>{equipment.manufacturer}</div>
                        <div style={{ width: '30%' }}>{equipment.model}</div>
                      </div>
                      <div>{equipment.description}</div>
                      {equipment.features && <div className="mt-1">{equipment.features}</div>}
                    </div>
                  </div>
                ))}
            </div>

            {optionalItems.length > 0 && (
              <div className="border">
                <div className="px-2 py-1 fw-bold text-uppercase" style={{ color: bucket.headerColor, backgroundColor: '#f5f5f5' }}>Optional Items</div>
                {optionalItems.map((item: any, index: number) => (
                  <div className="d-flex justify-content-between px-2 py-2 border-top" key={`${item.partNumber}-${index}`}>
                    <span>[{item.isAddOnSelected ? 'X' : ' '}] {item.description}</span>
                    <span>{formatAmount(item.amount)}</span>
                  </div>
                ))}
              </div>
            )}

            <div className="sales-quote-summary" style={barStyle}>
              <div className="sales-quote-summary-primary">
                <SummaryCell label="Pricing" value={total} />
                <SummaryCell label="Add Ons" value={addons} />
                <SummaryCell label="Coupons" value={coupons} />
                <SummaryCell label="Optional" value={optional} />
              </div>
              <div className="sales-quote-summary-secondary">
                <div className="sales-quote-summary-subtotal"><SummaryCell label="Subtotal" value={subtotal} /></div>
                <div className="sales-quote-summary-payment"><SummaryCell label="Payment Received" value={paymentReceived} /></div>
                <div className="sales-quote-summary-final"><SummaryCell label="Final" value={final} /></div>
              </div>
            </div>
          </Card>
        );
      })}
    </>
  );
};

export default SalesQuoteDetailQuote;
